import useTranslation from '@CS/hooks/useTranslation';
import { Popup } from '@CS/components/Popups';
import Content from './content';

import {
  Title,
  Button,
  Triangle,
  Description,
  PopupContent
} from './AvatarCreatePopup.styles';

type AvatarCreatePopupProps = {
  onClose: () => void;
};

export const AvatarCreatePopup = ({ onClose }: AvatarCreatePopupProps) => {
  const { title, description, button } = useTranslation(Content);

  return (
    <Popup
      onClose={onClose}
      width={90}
      hideClose
      customStyle={{
        maxWidth: '295px',
        padding: '24px 20px',
        overflow: 'visible',
        top: '53%',
        left: '54%',
        minHeight: '168px',
      }}
    >
      <PopupContent>
        <Triangle />
        <Title>{title}</Title>
        <Description>
          {description}
        </Description>
        <Button onClick={onClose}>{button}</Button>
      </PopupContent>
    </Popup>
  );
};
